import { env } from '@/env';
import utils from '@/common/utils';

const _data = [
  {
    icon: '//img30.360buyimg.com/pop/jfs/t1/188486/19/29111/8050/633532b0E01bc05dc/4d6dae463b6364de.png',
    link: '/material/#/product',
    title: '营销投放',
    desc: '营销投放平台是集素材录入，素材管理，素材分发为一体的可视化智能平台。',
    type: 2,
  },
  {
    ext: 'hd_gallery_1606447516680|7',
    icon: '//img30.360buyimg.com/pop/jfs/t1/159609/35/27754/4108/63317251Eeb0fcf3a/39e8f95ce52251a7.png',
    link: '/pandora/#/',
    title: '潘多拉选品',
    desc: '面向前台流量场景的智能选品工具，覆盖商品、内容、店铺等多种素材选型方式，精准匹配新人、下沉、校园等人群。',
    type: 2,
  },
  {
    ext: 'hd_gallery_1606447516680|6',
    icon: '//img30.360buyimg.com/pop/jfs/t1/122961/16/26465/4442/63317241E500f904a/bfe4e661a8b47139.png',
    link: 'https://babel.m.jd.com/active/babelCommon/index.html#/',
    title: '通天塔',
    desc: '活动/频道页面可视化搭建平台，支持一次搭建输出H5、原生、PC等多端页面，供产研、采销运营、商家等用户免费使用。',
    type: 2,
  },
  {
    ext: 'hd_gallery_1606447516680|8',
    icon: '//img30.360buyimg.com/pop/jfs/t1/16949/2/19156/2482/63317260Ea0b63a97/3d879469ea60caeb.png',
    link: 'https://ling.jd.com/design',
    title: '羚珑制图',
    desc: '羚珑是一个为事业部/商家提供海量版权素材的智能设计平台，小白也能轻松使用。',
    type: 2,
  },
  {
    ext: 'hd_gallery_1608023717804|2',
    icon: '//img30.360buyimg.com/pop/jfs/t1/20331/25/18967/8203/6331728dE1744beed/fe66418511cf4410.png',
    link: 'http://cmc2.jd.com/#/index',
    title: '优惠券创建',
    desc: '优惠券创建，可以按需圈选商品范围，设置领取及展示规则，成本分摊规则；满足多样化营销诉求，提升用户转化。',
    type: 2,
  },
  {
    icon: '//img30.360buyimg.com/pop/jfs/t1/132958/32/26611/4122/633532a0E3f8403e6/a45176ff5b74f16d.png',
    link: 'http://label.jinghailu.jd.com/',
    title: '经海路',
    desc:
      '零售统一标签平台，沉淀海量标签资产，为用户提供标签生产、管理、应用（画像分析、圈人、选品）、服务的能力，支持业务进行精细化运营。',
    type: 2,
  },
  {
    icon: '//img30.360buyimg.com/pop/jfs/t1/159089/5/30899/5652/6335328bE22d45945/b7eb58fcc3976107.png',
    link: '/interaction/#/',
    title: '互动工坊',
    desc: '互动工坊提供丰富的互动组件和通用服务，可自由组合、搭建不同互动玩法，助力不同场景下高效营销。',
    type: 2,
  },
  {
    icon: '//m.360buyimg.com/babel/jfs/t1/118935/3/34002/12711/63b535b1F5cca5296/d35eef0ea8445982.png',
    link: 'http://erp.jd.com/portal/navMenu/subPage?menuId=52093',
    title: '试用创建平台',
    desc: '为京东提供试用品应用全场景管理，为品牌方提供一站式试用品派发平台，提升获客效率和用户购买转化率。',
    type: 2,
  },
  // {
  //   icon: '//img30.360buyimg.com/pop/jfs/t1/180859/40/35557/2424/64bf7e2aF685d1986/bc2e0e11902d8760.png',
  //   link: 'http://admin.ads.jd.com/',
  //   title: '京准通',
  //   type: 2,
  // },
  {
    icon: '//img30.360buyimg.com/pop/jfs/t1/187419/16/30865/2082/63bcff73Fb41162d4/b584da8f561468c4.png',
    link: '/materials/tb-tools',
    title: '工具箱',
    desc:
      '营销中心工具箱，为用户提供日常活动信息查询、主题活动信息查询，跨收品池素材查重、标签审核、云交易入池等便捷功能。',
    type: 2,
  },
];

export const data = JSON.stringify(_data);
